<template>
  <BlockDiscipline
    :key="category.id"
    :library-book-id="currentContent.id"
    no-header
    :category="category"
  />
</template>
<script lang="ts" setup>
const { categoryManager, currentContent } = inject(INJECT_CATEGORY_PAGE);
const { category } = categoryManager;
</script>
